export default "__VITE_ASSET__$paNr1wt__"